module.exports = __webpack_public_path__ + "static/media/16c-04_Pasaje-4-2016-405x295mm-oleo-sobre-papel.82512bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16c/16c-04_Pasaje-4-2016-405x295mm-oleo-sobre-papel.jpg
// module id = 195
// module chunks = 0